import Select, { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import React from "react";
import { list as getLogists } from "sources/books/employees";

export default function LogistFilter(props) {
    const selectProps = {
        ...defaultMultipleSelectProps,
        components: { ValueContainer },
        inputProps: { name: "logistIds" },
        value: props.values.logistIds,
        placeholder: "Логист",
        url: getLogists,
        propName: "fullNameOrEmail",
        onChange: props.setFilter,
        className: "report__filters--control",
        styles: {
            control: (styles) => ({ ...styles, minHeight: "31px", fontSize: "14px" }),
            indicatorsContainer: (styles) => ({ ...styles, height: "29px" }),
        },
    };
    return (
        <div className="mb-md-0 report__filters--mr">
            <Select {...selectProps} />
        </div>
    );
}
